import React, { useEffect } from "react"; // w/o a fetchMore function this is essentially a noop

var useInfiniteScroll = function useInfiniteScroll(fetchMore) {
  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isEmptyElement = !element || Object.keys(element).length === 0;

  var isEndOfScroll = function isEndOfScroll(_ref) {
    var scrollTop = _ref.scrollTop,
        clientHeight = _ref.clientHeight,
        scrollHeight = _ref.scrollHeight;
    return Math.round(scrollTop) + clientHeight >= scrollHeight;
  };

  var scroll = function scroll() {
    if (!isEmptyElement && isEndOfScroll(element)) {
      fetchMore();
    }
  };

  useEffect(function () {
    if (isEmptyElement || typeof fetchMore !== "function") return;
    element.addEventListener("scroll", scroll);
    return function () {
      element.removeEventListener("scroll", scroll);
    };
  }, [element, scroll, fetchMore, isEmptyElement]);
};

export default useInfiniteScroll;